import _ from 'lodash';

// replacing with a regex in order to replace all occurences.
export const getImage = label =>
  _.replace(
    process.env.PUBLIC_URL +
      '/assets/images/serviceTypes/' +
      label.toLowerCase() +
      '.png',
    new RegExp(' ', 'g'),
    '_'
  );
